import { render, staticRenderFns } from "./nav-steps.vue?vue&type=template&id=c1523418&"
import script from "./nav-steps.vue?vue&type=script&lang=ts&"
export * from "./nav-steps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavStepIcon: require('/home/vsts/work/1/s/frontend/components/nav/nav-step-icon.vue').default})
